import styled from 'styled-components'

export const AlertBoxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e74c3c;
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  margin: 1rem;
`

export const AlertMessage = styled.span`
  flex-grow: 1;
  margin-right: 8px;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
`